// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiHandlerDiscreteParameter, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { GetShipTosApiParameter } from "@insite/client-framework/Services/CustomersService";
import { chain, DispatchBeginLoadShipTos } from "@insite/client-framework/Store/Pages/Addresses/Handlers/LoadShipTos";
import { ShipToCollectionModel, ShipToModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = ApiHandlerDiscreteParameter<
    {},
    GetShipTosApiParameter,
    ShipToCollectionModel,
    {
        newShipTo?: ShipToModel;
        dataViewParameter: GetShipTosApiParameter;
    }
>;

export const XngDispatchBeginLoadShipTos: HandlerType = props => {
    props.dataViewParameter = {
        ...props.getState().pages.addresses.getShipTosParameter,
        exclude: ["showAll", "oneTime"],
    };
    props.dispatch({
        type: "Data/ShipTos/BeginLoadShipTos",
        parameter: props.dataViewParameter,
    });
};

replaceInChain(chain, DispatchBeginLoadShipTos, XngDispatchBeginLoadShipTos);
